import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "client/slices/authSlice";
import allRoutes from "client/constants/allRoutes";

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  // If Redux says authenticated but no token exists, it's stale persisted state
  if (isAuthenticated && !token) {
    dispatch(logout());
    return element;
  }

  if (isAuthenticated) {
    return <Navigate to={allRoutes.portal} replace />;
  }

  return element;
};

export default ProtectedRoute;
